export const removeBracket = str => str.substr(1, str.length - 2);

function removeEnum(key, op, value) {
  const start = value.indexOf('\'');
  const end = value.length;
  const finalValue = value.substr(start + 1, end - start - 2);
  return `${key} ${op} '${finalValue}'`;
}

export const odataConfigForMyReport = {
  odata: {
    custom: {
      Name: (op, value) => `contains(tolower(Name), '${value.toLowerCase().replace(/'/g, '\'\'')}')`,
      DateRangePreset: (op, value) => {
        if (value === "Enum.DateRangePreset'Custom'") {
          return `ReportTime/DateRangePreset ${op} null`;
        }
        return removeEnum('ReportTime/DateRangePreset', op, value);
      },
      Frequency: (op, value) => removeEnum('Frequency', op, value),
      ReportType: (op, value) => removeEnum('ReportType', op, value),
    },
  },
};

export const asyncCallWithTimeout = async (asyncPromise, timeLimit) => {
  let timeoutHandle;

  const timeoutPromise = new Promise((_resolve, reject) => {
    timeoutHandle = setTimeout(
      () => reject(new Error('timeout')),
      timeLimit
    );
  });

  return Promise.race([asyncPromise, timeoutPromise]).then((result) => {
    clearTimeout(timeoutHandle);
    return result;
  });
};
